import { TrackingEvent } from '../types';

// Please update `./README.md` when changing the tracking configuration!

export const cancelledIntroSearch = (query: string, countResults: number): TrackingEvent[] => [{
    category: 'intro search',
    action: 'cancel - intro search',
    name: query,
    value: countResults > 0 ? 1 : 0,
}];
